// extracted by mini-css-extract-plugin
export default {"login":"jjPduP","logOutText":"YT_9QV"};